import React, { memo, useCallback, useMemo } from 'react';
import { formGroup, formControl, FormDataType, useFormState, useFormConfig } from '@core/utils/form';
import { defineBlockAdvanceForm } from '../Common/AdvanceSettings';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { useConfigureBlock, useCourseForm } from '@modules/course/CourseBuilder/hooks';
import { CourseBuilder } from '../types';
import { BlockContainer } from '../BlockContainer';
import { Card, CardBody } from 'reactstrap';
import { HTMLService } from '@business/services';
import { Container } from 'reactstrap';
import { useBloc } from '@core/utils/bloc';
import './index.scss';
import { FormHTML } from '@core/components/form/FormHTML';
import { DocumentBlockBloc } from './DocumentBlockBloc';
import { DocumentBlockSettings } from './DocumentBlockSettings';
import { FormInput } from '@core/components/form';

export enum DocumentBlockVariation {
  document = 'document',
}

function defineDocumentBlockForm() {
  return formGroup({
    title: formControl<string>({
      placeholder: 'Name',
      label: 'Name',
      initialValue: '',
    }),
    content: formControl<string>({
      label: 'Content',
    }),
    author: formControl<string>({
      label: 'Author',
    }),
    // disableGlossaryLinks: formControl<boolean>({
    //   label: 'Disable Glossary Links',
    // }),
    advance: defineBlockAdvanceForm({ paddingBottom: 30, paddingTop: 30 }),
  });
}

export type DocumentForm = ReturnType<typeof defineDocumentBlockForm>;
export type DocumentFormData = FormDataType<typeof defineDocumentBlockForm>;

export const DocumentBlock = memo((props: CourseBuilder.BlockProps<DocumentBlockVariation>) => {
  const { variation, preview, lessonId, editable, step } = props;
  const form = useMemo(() => defineDocumentBlockForm(), []);
  const formValue = useNonNilObservable(form.value$);
  const bloc = useBloc(DocumentBlockBloc, lessonId);

  useConfigureBlock({
    props,
    form,
    contentComponent: DocumentBlockSettings,
    contentProps: { form, variation },
  });

  const onSubmit = useCallback(() => {
    return bloc.submitEssay(lessonId || '', {
      ...formValue,
      stepId: step?.id,
      blockId: props.id,
      type: 'document',
    });
  }, [bloc, formValue, lessonId, props.id, step]);

  useFormConfig(form, { onSubmit });
  const { submitting } = useFormState(form, { submitting: true });

  useCourseForm(props.id, form, { onSubmit });

  return (
    <Container>
      <BlockContainer advanceForm={formValue.advance}>
        <Card className="mt-4">
          <CardBody>
            {/* <h1 className="mb-3">{HTMLService.toReact(formValue.title)}</h1> */}
            <FormInput control={form.controls.title} />
            <hr />
            <FormHTML control={form.controls.content} disabled={!editable} />
            <FormInput control={form.controls.author} />
          </CardBody>
        </Card>
      </BlockContainer>
    </Container>
  );
});
